import {fabric} from 'fabric';

interface AutoFitScale {
  (activeObject: fabric.Object & {srcScale: number}, originalObject: fabric.Object): number;
}

export const autoFitScale: AutoFitScale = (activeObj, originalObject) => {
  const activeObjWidth = (activeObj.scaleX || 1) * (activeObj?.width || 0);
  const activeObjHeight = (activeObj.scaleY || 1) * (activeObj?.height || 0);
  const originalObjectWidth = (originalObject.scaleX || 1) * (originalObject?.width || 0);
  const originalObjectHeight = (originalObject.scaleY || 1) * (originalObject?.height || 0);

  return Math.max(originalObjectWidth / activeObjWidth, originalObjectHeight / activeObjHeight);
};
